export const ADDRESS_FIELDS = {
  ADDRESS: 'address',
  FLOOR: 'floor'
};

export const PERSONAL_DOCUMENTATION_FORM = 'PersonalDocumentationForm';
export const GUARANTOR_PERSONAL_DOCS_FORM = 'GuarantorPersonalDocumentationForm';
